export const CONTRACTS_QUERY_SEARCH_PARAM_KEY = 'contractQuery';
